export const navigationFlyoutItem = () => ({
  interval: undefined,
  show: false,

  /* -------------------------------- FUNCTIONS ------------------------------- */
  open() {
    this.show = true;
    this.$refs.navigationFlyoutItem.classList.add('opacity-100');
    this.$refs.navigationFlyoutItem.classList.remove('opacity-0');
  },
  close() {
    this.show = false;
    this.$refs.navigationFlyoutItem.classList.add('opacity-0');
    this.$refs.navigationFlyoutItem.classList.remove('opacity-100');
  },
  toggle() {
    if (this.show) {
      this.close();
    } else {
      this.open();
    }
  },
  onMouseEnter() {
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => this.open(), 300);
  },
  onMouseLeave() {
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => this.close(), 400);
  },
});
